import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  "@global": {
    body: {
      overflow: (props: any) => (props.show ? "hidden" : "auto"),
    },
  },
  toggleSection: {
    borderBottom: "1px solid #CCC",
    left: 0,
    top: 0,
    right: 0,
    background: "#FFF",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 20px",
    zIndex: 1,
  },
  surveyPopupOverlay:{
     position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)", // 👈 semi-transparent dark background
    zIndex: 999, // keep above everything
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  estimatePopupContainer: {
    position: "fixed",
    background: "#FFF",
    left: 100,
    top: 80,
    right: 100,
    bottom: 48,
    padding: "20px 20px 80px",
    overflow: "auto",
     borderRadius: "5px",
    border: "2px solid #CCC",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
    "& .MuiGrid-root": {
      marginBottom: "10px !important",
    },
    "& .MuiFormControl-root": {
      background: "none",
      margin: 0,
      height: "20px",
      "& > div": {
        height: "21px",
      },
      "& input": {
        fontSize: "12px",
      },
      "& select": {
        fontSize: "12px",
      },
    },
    "& .MuiRadio-root": {
      margin: 0,
      padding: 0,
      textAlign: "center",
      width: "100%",
    },
    /* 📱 Mobile Responsive */
  "@media (max-width:768px)": {
    left: 10,
    right: 10,
    top: 60,
    bottom: 10,
    padding: "15px",

    "& .MuiFormControl-root": {
      height: "auto",

      "& input": {
        fontSize: "14px",
      },

      "& select": {
        fontSize: "14px",
      },
    },
  },
  },
  popupTitle: {
    position: "fixed",
    borderBottom: "1px solid #CCC",
    left: 100,
    top: 80,
    right: 100,
    background: "#FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 20px",
    border: "2px solid #CCC",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
    zIndex: 1,
    "& h6": {
      padding: "0px",
      fontWeight: "600!important" as any,
    },
    /* 📱 MOBILE FIX */
  "@media (max-width:768px)": {
    left: 10,
    right: 10,
    top: 10,
    padding: "0px 10px",
  },
  },

  // survey summary details

  surveySummaryPopupContainer: {
    // position: "fixed",
    // background: "#FFF",

    // padding: "20px 20px 80px",
    marginTop: "16px !important",
    overflow: "auto",
    "& .MuiFormControl-root": {
      // marginTop: '16px !important',
      height: "36px",
      "& > div": {
        height: "36px !important",
        paddingTop: "0px !important",
      },
      "& input": {
        fontSize: "12px",
      },
      "& select": {
        fontSize: "12px",
      },
    },
    "& .MuiRadio-root": {
      // margin: 0,
      // padding: 0,
      textAlign: "center",
      width: "100%",
    },
  },
  //
  //   side bar
  sidebarContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100px",
    backgroundColor: "#ffffff",
    boxShadow: "2px 0px 10px rgba(0, 0, 0, 0.2)",
    transition: "transform 0.3s ease-in-out",
    zIndex: 9,
  },
  sidebarOpen: {
    transform: "translateX(0)",
  },
  sidebarClosed: {
    transform: "translateX(-100%)",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    opacity: 0,
    transition: "opacity 0.3s ease-in-out",
    pointerEvents: "none",
  },
  overlayVisible: {
    opacity: 1,
    pointerEvents: "auto",
  },
});

export default useStyles;
